import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import '../ConnexionForm/login.css';
import './signup.css';
import logo from '../../image/logo.png';
import { useFormContext } from 'react-hook-form';
import { useRegisterUserMutation } from 'actions/auth/mutations';
import iconeInscription from '../../image/iconeInscription.png';
import { LOGIN_PATH } from 'routes/navigation/navigationPaths';
import { ToastContainer, toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {
  RiCustomerService2Line,
  RiRocketLine,
  RiUserAddLine,
} from 'react-icons/ri';

const FEATURES = [
  {
    icon: RiUserAddLine,
    title: 'Inscription en 2 minutes',
    desc: 'Créez votre compte et commencez immédiatement',
  },
  {
    icon: RiRocketLine,
    title: 'Prise en main rapide',
    desc: 'Interface intuitive, zéro complexité',
  },
  {
    icon: RiCustomerService2Line,
    title: 'Accompagnement expert',
    desc: 'Une équipe à vos côtés à chaque étape',
  },
];

const InscriptionForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [registerUser] = useRegisterUserMutation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useFormContext();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({
    email: '',
    phone: '',
    password: '',
  });

  const password = watch('password');
  const passwordConfirmation = watch('passwordConfirmation');

  const onSubmit = (data) => {
    if (password !== passwordConfirmation) {
      setError({ ...error, password: 'Les mots de passe ne correspondent pas' });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('first_name', data.first_name);
    formData.append('last_name', data.last_name);
    formData.append('phone', data.phone);
    formData.append('adresse', data.adresse);
    formData.append('email', data.email);
    formData.append('password', data.password);
    formData.append('re_password', data.password);

    registerUser(formData)
      .unwrap()
      .then((res) => {
        console.log(res);
        if (res?.email_sent === false) {
          // Compte créé mais email non envoyé (service email indisponible)
          toast.warning(
            res?.email_warning ||
              "Votre compte a été créé avec succès, mais l'email d'activation n'a pas pu être envoyé. Votre compte a été activé automatiquement, vous pouvez vous connecter."
          );
        } else {
          toast.success(
            'Nous avons envoyé le lien d\'activation dans votre boîte de réception. Activez votre compte à partir de votre messagerie.'
          );
        }
        navigate(LOGIN_PATH);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.data?.message || err?.message || 'Inscription échouée');
        if (err?.data) {
          setError(err.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="login-page signup-page">
        <aside className="login-brand" aria-hidden="true">
          <div className="login-brand-bg">
            <div className="login-blob login-blob-1" />
            <div className="login-blob login-blob-2" />
            <div className="login-blob login-blob-3" />
          </div>

          <div className="login-brand-inner">
            <div className="login-brand-logo">
              <img src={logo} alt="Easy Compta" />
            </div>

            <div className="login-brand-content">
              <h2 className="login-brand-title">
                Rejoignez la révolution comptable
              </h2>
              <p className="login-brand-subtitle">
                Créez votre compte et accédez à une plateforme conçue pour
                simplifier votre gestion financière au quotidien.
              </p>

              <ul className="login-features">
                {FEATURES.map(({ icon: Icon, title, desc }) => (
                  <li key={title} className="login-feature">
                    <span className="login-feature-icon">
                      <Icon />
                    </span>
                    <div className="login-feature-text">
                      <strong>{title}</strong>
                      <span>{desc}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="login-brand-illustration">
              <img src={iconeInscription} alt="" />
            </div>
          </div>
        </aside>

        <main className="login-form-panel">
          <div className="login-form-card">
            <div className="login-mobile-logo">
              <img src={logo} alt="Easy Compta" />
            </div>

            <header className="login-form-header">
              <h1>Créer un compte</h1>
              <p>Démarrez avec Easy Compta en quelques secondes</p>
            </header>

            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" noValidate>
              <div className="signup-form-grid">
                <div className="signup-field-group signup-span-2">
                  <label>Prénom et nom</label>
                  <div className="signup-field-row">
                    <div className="login-field">
                      <input
                        className="login-input"
                        type="text"
                        placeholder="Prénom"
                        {...register('first_name', {
                          required: 'Le prénom est obligatoire',
                        })}
                      />
                      {errors.first_name?.message && (
                        <div className="login-field-error">
                          {errors.first_name.message}
                        </div>
                      )}
                    </div>
                    <div className="login-field">
                      <input
                        className="login-input"
                        type="text"
                        placeholder="Nom"
                        {...register('last_name', {
                          required: 'Le nom est obligatoire',
                        })}
                      />
                      {errors.last_name?.message && (
                        <div className="login-field-error">
                          {errors.last_name.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="login-field">
                  <label htmlFor="phone">Téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    className="login-input"
                    placeholder="77 000 00 00"
                    {...register('phone', {
                      required: 'Le téléphone est obligatoire',
                    })}
                  />
                  {errors.phone?.message && (
                    <div className="login-field-error">{errors.phone.message}</div>
                  )}
                  {error.phone !== '' && error.phone && (
                    <div className="login-field-error">{error.phone}</div>
                  )}
                </div>

                <div className="login-field">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="login-input"
                    placeholder="vous@exemple.com"
                    {...register('email', {
                      required: "L'email est obligatoire",
                    })}
                  />
                  {errors.email?.message && (
                    <div className="login-field-error">{errors.email.message}</div>
                  )}
                  {error.email !== '' && error.email && (
                    <div className="login-field-error">{error.email}</div>
                  )}
                </div>

                <div className="login-field signup-span-2">
                  <label htmlFor="adresse">Adresse</label>
                  <input
                    type="text"
                    id="adresse"
                    className="login-input"
                    placeholder="Votre adresse"
                    {...register('adresse')}
                  />
                  {errors.adresse?.message && (
                    <div className="login-field-error">
                      {errors.adresse.message}
                    </div>
                  )}
                </div>

                <div className="login-field">
                  <label htmlFor="password">Mot de passe</label>
                  <div className="login-input-wrap">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      className="login-input login-input-password"
                      placeholder="Min. 8 caractères"
                      {...register('password', {
                        required: 'Le mot de passe est obligatoire',
                        minLength: {
                          value: 8,
                          message:
                            'Le mot de passe doit contenir au moins 8 caractères',
                        },
                      })}
                    />
                    <button
                      type="button"
                      className="login-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword
                          ? 'Masquer le mot de passe'
                          : 'Afficher le mot de passe'
                      }
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {errors.password?.message && (
                    <div className="login-field-error">
                      {errors.password.message}
                    </div>
                  )}
                  {error.password && (
                    <div className="login-field-error">{error.password}</div>
                  )}
                </div>

                <div className="login-field">
                  <label htmlFor="passwordConfirmation">Confirmation</label>
                  <div className="login-input-wrap">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="passwordConfirmation"
                      className="login-input login-input-password"
                      placeholder="Confirmez"
                      {...register('passwordConfirmation', {
                        required: 'La confirmation est obligatoire',
                        minLength: {
                          value: 8,
                          message:
                            'Le mot de passe doit contenir au moins 8 caractères',
                        },
                      })}
                    />
                    <button
                      type="button"
                      className="login-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword
                          ? 'Masquer le mot de passe'
                          : 'Afficher le mot de passe'
                      }
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {errors.passwordConfirmation?.message && (
                    <div className="login-field-error">
                      {errors.passwordConfirmation.message}
                    </div>
                  )}
                </div>

                <p className="signup-terms signup-span-2">
                  En vous inscrivant, vous acceptez les{' '}
                  <strong>conditions d&apos;utilisation</strong> et la{' '}
                  <strong>politique de confidentialité</strong> de Bakeli.
                </p>

                <button
                  type="submit"
                  className="login-submit signup-span-2"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="login-loader" aria-label="Inscription en cours" />
                  ) : (
                    "S'inscrire"
                  )}
                </button>
              </div>
            </form>

            <p className="login-footer">
              Vous avez déjà un compte ?{' '}
              <Link to={LOGIN_PATH}>Se connecter</Link>
            </p>
          </div>
        </main>
      </div>
    </>
  );
};

export default InscriptionForm;
